import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {EMPTY, Observable} from 'rxjs';
import {AppConfig} from '../app-config';
import {factory} from '../app-logging';
import {Injectable, Injector} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from '../../services/auth.service';
import {environment} from '../../../environments/environment';
import {RedirectService} from '../../services/redirect.service';

const logger = factory.getLogger('TokenInterceptor');

const DOMAINS_NOT_REQUIRING_COOKIES: string[] = [
  environment.ngpServiceCatalogReferenceApiBaseUrl,
  environment.userNavApi,
];

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private redirector: RedirectService;
  private cookieService: CookieService;
  private authService: AuthService;

  constructor(private injector: Injector) {
    this.redirector = this.injector.get(RedirectService);
    this.cookieService = this.injector.get(CookieService);
    this.authService = this.injector.get(AuthService);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip cookies for domains that don't require them
    if (DOMAINS_NOT_REQUIRING_COOKIES.some(domain => request.url.startsWith(domain))) {
      logger.info('No token required for URL: ' + request.url);
      return next.handle(request.clone({ withCredentials: false }));
    }

    // Otherwise ensure cookies are used
    if (this.cookieService.check(AppConfig.sessionTokenVariableName)) {
      if (!this.authService.isLoggedIn()) {
        this.authService.takeLoginDetailsFromCookie();
      }

      let req = request.clone({
        withCredentials: true
      });

      if (!req.headers.has('Content-Type')) {
        req = req.clone({headers: req.headers.append('Content-Type', 'application/json')});
      }

      if (!req.headers.has('Accept')) {
        req = req.clone({headers: req.headers.append('Accept', 'application/json')});
      }

      // Continue execution with modified request
      return next.handle(req);
    } else {
      this.authService.logout();
      this.redirector.goToLoginPage();

      // Cancel request
      return EMPTY;
    }
    // Continue Request Execution
    // return next.handle(request);
  }
}
